require './ui/sm-checkbox'

###
# Checkbox in sidebar
###
App.RecurrenceFilterItemComponent = App.SmCheckboxComponent.extend
  env: Em.inject.service('environment')

  label: (->
    @get('env').translate("clients.recurrence_filter.#{@get('recurrenceValue.type')}")
  ).property('recurrenceValue.type')

  checked: Em.computed.alias('recurrenceValue.checked')

  # label: 'Yo'
  # checked: false
  layoutName: 'components/sm-checkbox'
